import { jobGuidManagerFactory } from '@shipstation/async-client-manager';
import { getIsJobComplete } from './pusher-helpers';
import { LogService } from '../../../services/log-service';

const BULK_UPDATE_ALLOWED_RETRIES = 3;
export const createFallbackListeners = () => {
  const jobGuidManager = jobGuidManagerFactory();
  const fallbackOptions = {
    timeoutMs: 15000,
    jobGuidManager,
    resetTimeoutCheck: (pusherMsg, jobGuids) => {
      if (!jobGuids.includes(pusherMsg.messageGuid)) {
        return false;
      }
      return true;
    },
    completeCheck: (pusherMsg, jobGuids) => {
      if (!jobGuids.includes(pusherMsg.messageGuid)) {
        return false;
      }
      if (getIsJobComplete(pusherMsg)) {
        return true;
      }
      return false;
    },
    timeoutCompleteCheck: ({ messages }) => {
      let isComplete = false;
      messages.forEach((message) => {
        if (getIsJobComplete(message)) {
          isComplete = true;
        }
      });
      return isComplete;
    },
    timeoutRetryCheck: ({ retryCount }) => {
      if (retryCount < BULK_UPDATE_ALLOWED_RETRIES) {
        return true;
      }
      return false;
    },
    timeoutFailureCheck: ({ retryCount }) => {
      if (retryCount >= BULK_UPDATE_ALLOWED_RETRIES) {
        return true;
      }
      return false;
    },
    onTimeout: (logContext) => {
      LogService.logInfo('bulk update timeout', logContext);
    },
  };

  return { jobGuidManager, fallbackOptions };
};
